import { z } from 'zod';

// Enum fields are parsed as plain strings so a value added to the contract later
// renders raw instead of failing the whole page.

// ── Delivery Recipient ──────────────────────────────────
const RecipientApiSchema = z.object({
  kind: z.string(),
  id: z.string().nullable(),
  name: z.string().nullable(),
});

// ── Notification Delivery list item → DTO ───────────────
export const NotificationDeliveryListItemApiSchema = z.object({
  id: z.string(),
  created_at: z.string(),
  notification_type: z.string(),
  channel: z.string(),
  status: z.string(),
  recipient: RecipientApiSchema,
  attempt_count: z.number(),
  last_attempt_at: z.string().nullable(),
  is_secret_bearing: z.boolean(),
  can_retry: z.boolean(),
});

export function toNotificationDeliveryListItem(
  raw: z.infer<typeof NotificationDeliveryListItemApiSchema>
) {
  return {
    id: raw.id,
    createdAt: raw.created_at,
    notificationType: raw.notification_type,
    channel: raw.channel,
    status: raw.status,
    recipient: raw.recipient,
    attemptCount: raw.attempt_count,
    lastAttemptAt: raw.last_attempt_at,
    isSecretBearing: raw.is_secret_bearing,
    canRetry: raw.can_retry,
  };
}

const NotificationDeliveryListItemSchema =
  NotificationDeliveryListItemApiSchema.transform(
    toNotificationDeliveryListItem
  );

export type NotificationDeliveryListItemDTO = z.infer<
  typeof NotificationDeliveryListItemSchema
>;

// ── Paginated response ─────────────────────────────────
const GetNotificationDeliveriesApiSchema = z
  .object({
    result: z
      .object({
        data: z.array(NotificationDeliveryListItemSchema),
        total_data: z.number(),
        per_page: z.number(),
        current_page: z.number(),
        last_page: z.number(),
        first_page: z.number(),
      })
      .transform(raw => ({
        data: raw.data,
        totalData: raw.total_data,
        perPage: raw.per_page,
        currentPage: raw.current_page,
        lastPage: raw.last_page,
        firstPage: raw.first_page,
      })),
  })
  .transform(raw => raw.result);

export type GetNotificationDeliveriesDTO = z.infer<
  typeof GetNotificationDeliveriesApiSchema
>;

export function toGetNotificationDeliveriesDTO(
  raw: unknown
): GetNotificationDeliveriesDTO {
  return GetNotificationDeliveriesApiSchema.parse(raw);
}
